import { Component, OnInit } from '@angular/core';
import { LoginService } from 'src/app/services/login.service';
@Component({
  selector: 'services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.less'],
})
export class ServicesComponent implements OnInit {
  isHomeBak: boolean = false;
  services = [
    { title: '汽车维修培训', category: '技术培训及支持', image: 'assets/official-website/service-training.png', link: '/gb/cn/services/training-solutions/service-training/' },
    { title: '培训中心', category: '技术培训及支持', image: 'assets/official-website/equipment-services.png', link: '/gb/cn/services/service-solutions/equipment-services'},
    { title: 'FRC博世车联', category: '维修站生态体系', image: 'assets/official-website/bscl.png', link: 'https://www.boschcarservice.com.cn/' },
    { title: 'BDx博世柴油系统服务网络', category: '维修站生态体系', image: 'assets/official-website/bdx-1.png', link: '/gb/cn/services/workshop-concepts/bosch-diesel-repair-network'},
    { title: 'BSS博世乘用车配件优选', category: '维修站生态体系', image: 'assets/official-website/BSS.jpg', link: '/gb/cn/services/workshop-concepts/bss-parts-selection-store' },
    { title: 'CV Plan博世商用车增值计划', category: '维修站生态体系', image: 'assets/official-website/CV.jpg', link: '/gb/cn/services/workshop-concepts/cv-plan'},
    { title: 'eXtra易加网', category: '增值计划', image: 'assets/official-website/extra-teaser.png', link: '/gb/cn/services/programs/extra-rewards' },
  ];
  constructor(
    public loginService: LoginService,
  ) { }
  ngOnInit(): void {
  }
}
